import { Avatar } from "@design-system/Avatar/Avatar";
import { Box } from "@design-system/Box/Box";
import { Skeleton } from "@design-system/Skeleton/Skeleton";
import { Text } from "@design-system/Text/Text";

type Props = {
  name?: string;
  email?: string;
  isLoading?: boolean;
};

export const User = ({ name, email, isLoading }: Props) => {
  return (
    <Box gap={8} align="center">
      <Avatar name={name} size="sm" />
      <Box direction="column" gap={2}>
        <Text size={14} weight={600}>
          {isLoading ? <Skeleton width={100} /> : name}
        </Text>
        {(email || isLoading) && (
          <Text size={10} weight={500} color="textSecondary">
            {isLoading ? <Skeleton width={160} /> : email}
          </Text>
        )}
      </Box>
    </Box>
  );
};
